<div class="footer-container">
    <div class="footer-content">
        <div class="d-flex">
            <a href="https://www.facebook.com/WINGS.ICT/" class="btn btn-floating animated-btn" role="button"
                target="_blank">
                <i class="fab fa-facebook-f"></i>
            </a>
            <a href="https://twitter.com/i/flow/login?redirect_after_login=%2Fwings_ict"
                class="btn btn-floating animated-btn" role="button" target="_blank">
                <i class="fab fa-twitter"></i>
            </a>
            <a href="https://www.linkedin.com/company/wings-ict-solutions" class="btn btn-floating animated-btn"
                role="button">
                <i class="fab fa-linkedin-in"></i>
            </a>
            <a href="https://www.youtube.com/channel/UCPotWFhjcmvgQAbBYMYhofQ" class="btn btn-floating animated-btn"
                role="button" target="_blank">
                <i class="fab fa-youtube"></i>
            </a>
        </div>
        <div class="d-flex flex-sm-row flex-column ">
            <a href="https://www.wings-ict-solutions.eu/" target="_blank">
                <img class="wings" src="../../../assets/img/wingslogo.png" alt="WINGS Logo">
            </a>
            @if (!environment.aigaleo && !environment.agrinio && !environment.mediaServer && !environment.people && !environment.structural || environment.flexi) {
            <div class="d-flex justify-content-between align-items-center p-0">
                <img class="me-2 flexi" src="../../../assets/img/Co-fundedEU_POS.jpg" alt="EU Logo">
                <a href="https://flexicross-project.eu/" target="_blank">
                    <img class="flexi" src="../../../assets/img/FLEXcross-logo.png" alt="Flexi Logo">
                </a>
            </div>
            }
        </div>
        <div>
            <h3>Copyright © 2025 WINGS ICT SOLUTIONS</h3>
        </div>
    </div>
</div>